<div id="page-contact">

    <div class="page-section-header contact-header">
        <p>Contact</p>
    </div>

    <div class="page-section-container">

        <form id="page-contact-form" [formGroup]="contactForm" (ngSubmit)="onSubmit(contactForm)">
            <div class="page-section-row">
                <app-page-input [placeholder]="'Name'" [tooltip]="'Enter your name'">
                    <input 
                    id="contactFormName"
                    type="text" 
                    size="75"
                    maxlength="50"
                    class="page-input-input"  
                    formControlName="name"
                    #inputControl
                    />
                </app-page-input>
                @if(contactForm.controls['name'].touched) {
                    <small class="alert">
                        @if(contactForm.controls['name'].errors?.['required']) {
                            <span>Name is required</span>
                        }

                        @if(contactForm.controls['name'].errors?.["minlength"]) {
                            <span>Name must be at least 3 characters long</span>
                        }
                    </small>
                }
            </div>
            <div class="page-section-row">
                <app-page-input [placeholder]="'Email'" [tooltip]="'Enter your email address'">
                    <input 
                    type="email"
                    size="75"
                    maxlength="50"
                    class="page-input-input" 
                    formControlName="email"
                    #inputControl
                    />
                </app-page-input> 
                @if(contactForm.controls['email'].touched) {
                    <small class="alert">
                        @if(contactForm.controls['email'].errors?.["required"]) {
                            <span>Email is required</span>
                        }

                        @if(contactForm.controls['email'].errors?.["email"]) {
                            <span>Email address is required</span>
                        }
                    </small>
                }
            </div>
            <div class="page-section-row">
                <app-page-input [placeholder]="'Comments'" [tooltip]="'Enter your comments'" [controlType]="'multiline'">
                    <textarea 
                    formControlName="comments" 
                    rows="6" 
                    cols="73"
                    class="page-textarea-textarea" 
                    #inputControl
                    ></textarea>
                </app-page-input>
                @if(contactForm.controls['comments'].touched) {
                    <small class="alert">
                        @if(contactForm.controls['comments'].errors?.["required"]) {
                            <span>Comments are required</span>
                        }
                    </small>
                }
            </div>
            <div class="page-section-row form-group">
                <button type="submit" [disabled]="!contactForm.valid || isSubmitted" [style.opacity]="!contactForm.valid ? .4 : 1" style="background:transparent;border:0;">
                    <img src="assets/Submit.png" alt="Submit" style="width:125px" />
                </button>
            </div>
        </form>
    </div> 

    @if (isSubmitted) {
        <app-submission></app-submission>
    }
</div>
